Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpacing = void 0;
var _getREM = require("../../getREM");
var _useBreakpoints2 = require("./useBreakpoints");
var _baseSize = require("../../baseSize");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var useSpacing = exports.useSpacing = function useSpacing() {
  var _useBreakpoints = (0, _useBreakpoints2.useBreakpoints)(),
    bp = _useBreakpoints.bp;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var _insetLeftRem = insets.left / _baseSize.baseSize;
  var _insetRightRem = insets.right / _baseSize.baseSize;
  var _insetTopRem = insets.top / _baseSize.baseSize;
  var _insetBottomRem = insets.bottom / _baseSize.baseSize;
  var page = {
    padding: {
      paddingTop: (0, _getREM.getREM)(1.5 + _insetTopRem),
      paddingBottom: (0, _getREM.getREM)(1.5 + _insetBottomRem),
      paddingRight: (0, _getREM.getREM)(0.5 + _insetRightRem),
      paddingLeft: (0, _getREM.getREM)(0.5 + _insetLeftRem)
    }
  };
  if (bp.is([bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l, bp.mobile_xl])) {
    page.padding.paddingRight = (0, _getREM.getREM)(1 + _insetRightRem);
    page.padding.paddingLeft = (0, _getREM.getREM)(1 + _insetLeftRem);
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    page.padding.paddingTop = (0, _getREM.getREM)(3 + _insetTopRem);
    page.padding.paddingBottom = (0, _getREM.getREM)(3 + _insetBottomRem);
    page.padding.paddingRight = (0, _getREM.getREM)(2.5 + _insetRightRem);
    page.padding.paddingLeft = (0, _getREM.getREM)(2.5 + _insetLeftRem);
  }
  var spacing = {
    page: page,
    xxs: (0, _getREM.getREM)(0.25),
    xs: (0, _getREM.getREM)(0.5),
    s: (0, _getREM.getREM)(0.75),
    normal: (0, _getREM.getREM)(1),
    m: (0, _getREM.getREM)(1.125),
    l: (0, _getREM.getREM)(1.5),
    xl: (0, _getREM.getREM)(2),
    xxl: (0, _getREM.getREM)(2.5),
    xxxl: (0, _getREM.getREM)(3),
    xxxxl: (0, _getREM.getREM)(3.5)
  };
  return {
    spacing: spacing
  };
};